export const SKY_BLUE = '#39ACE7';
export const SOFT_RED = '#FE2626';
export const LIGHT_BLUE_BG = '#EFF6FF';
export const HEADER_TEXT = '#000000';
export const MUTED_TEXT = '#A9ADCB';
